import { LoaderRow } from "@circle-react-shared/LoaderRow";
import type { ReactNode } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { useCommentList } from "@/react/components/CommentsCompass/data/useCommentList";
import { useCommentsConfig } from "@/react/components/CommentsCompass/Provider/ConfigContext";
import { Thread } from "@/react/components/CommentsCompass/Thread";
import { useMemberAreaScrollContainerId } from "@/react/hooks/useMemberAreaScrollContainerId";

export interface ListViewProps {
  scrollableTarget?: HTMLElement | null;
}

export const ListView = ({ scrollableTarget }: ListViewProps) => {
  const { postId } = useCommentsConfig();
  const { comments, hasNextPage, fetchNextPage, isPending } = useCommentList({
    postId,
  });
  const fallbackScrollContainerId = useMemberAreaScrollContainerId();

  return (
    <>
      <InfiniteScroll
        key={scrollableTarget ? "elementTarget" : "idTarget"}
        dataLength={comments.length}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={<LoaderRow />}
        scrollableTarget={
          (scrollableTarget as ReactNode) ?? fallbackScrollContainerId
        }
        scrollThreshold={0.8}
        className="flex flex-col gap-1"
        style={{ overflow: "initial" }}
      >
        {comments.map(comment => (
          <Thread key={comment.id} comment={comment} />
        ))}
      </InfiniteScroll>
      {isPending && <LoaderRow />}
    </>
  );
};
